import tw from 'twin.macro'
import { useContext } from 'react'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'
import { LinkSubcontractorContext } from '../../LinkSubcontractor.context'
import { LinkSubcontractorTableContext } from '../LinkSubcontractorTable.context'
import { LinkContractorsButton } from '../../../assign-contractors/LinkContractorsButton'
import { LinkSubcontractorContractorStatusSelect } from './LinkSubcontractorContractorStatusSelect'
import { LinkSubcontractorBatchActionButton } from './LinkSubcontractorBatchActionButton'
import { LinkedSubcontractor } from 'src/interfaces/subcontractor'

interface Props {
  refreshLinkedContractors: () => void
  contractors: LinkedSubcontractor[]
}

export const LinkSubcontractorHeader = ({ refreshLinkedContractors, contractors }: Props) => {
  const { setSearchQuery, searchQuery, selectedMCCustomerId } = useContext(LinkSubcontractorContext)
  const { tagsFilter, setTagsFilter } = useContext(LinkSubcontractorTableContext)

  return (
    <div
      css={tw`flex flex-row items-center justify-between px-4 py-3 bg-white border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <div css={tw`flex flex-row items-center gap-2`}>
        <TableSearch
          searchQuery={searchQuery}
          onChangeSearchQuery={setSearchQuery}
          className="w-[284px]"
        />
        <LinkSubcontractorContractorStatusSelect />
        <TableTagsSelect selectedTags={tagsFilter} setSelectedTags={setTagsFilter} />
      </div>
      <div css={tw`flex gap-2`}>
        <LinkSubcontractorBatchActionButton contractors={contractors} />
        <LinkContractorsButton
          refreshLinkedContractors={refreshLinkedContractors}
          selectedMCCustomerId={selectedMCCustomerId}
        />
      </div>
    </div>
  )
}
